<template>
  <v-overlay v-if="$auth.isLoading || !$auth.isAuthenticated">
    <v-progress-circular
      indeterminate
      size="64">
    </v-progress-circular>
  </v-overlay>

  <v-app v-else id="inspire">
    <v-app-bar color="main" dark app clipped-left>
      <v-app-bar-nav-icon
        v-show="$auth.isAuthenticated"
        class="mx-auto"
        @click.stop="drawer = !drawer">
      </v-app-bar-nav-icon>
      <router-link :to="{ path: '/'}">
          <v-img v-if="tenantsWithLogos.includes(`${$auth.tenant}`)"
            max-height="110"
            max-width="110"
            class="ml-6"
            :src="require(`@/assets/${$auth.tenant}_logo.png`)"
            :alt="`${$auth.tenant} Logo`">
          </v-img>
          <v-app-bar-nav-icon v-else>
            <v-icon color="#fff">mdi-home</v-icon>
          </v-app-bar-nav-icon>
        </router-link>
      <v-spacer/>
      <VideoMenu v-if="$auth.tenant === 'awg'" />
      <v-col cols="auto" class="pr-0">
        <PortalNavMenu active="item" />
      </v-col>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      color="grey lighten-3"
      width="200"
      app>
      <v-list background-color="#fff">
        <v-list-item
          v-for="(link, i) in navLinks"
          :key="i"
          :to="{ path: link.path }"
          link>
          <v-icon>{{ link.icon }}</v-icon>
          <v-list-item-content>
            <v-list-item-title class="ml-2">
              {{ link.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div :class="[(!miniVariant) ? 'pa-2': 'pa-1']">
          <v-btn block id="logoutBtn"
            :style="styleObject"
            @click.prevent="logout()">
            <v-icon color="#fff">mdi-logout</v-icon>
            <span v-if="!miniVariant">Logout</span>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <Maintenance v-if="maintenanceStatus" />

    <v-main v-else class="grey lighten-3">
      <AlertBar></AlertBar>
      <router-view v-if="hasPortalAccess" />
      <v-alert
        v-else
        type="error"
        text
        border="left">
        You don't have authorized permissions to access this site.
      </v-alert>
    </v-main>
    <v-footer color="main" app class="justify-space-between">
      <span class="white--text">iPro <span class="registeredTrademark">&reg;</span> Systems, LLC. &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { userAccess } from '@/mixins/user-access'
import AlertBar from '@/components/AlertBar.vue'
const VideoMenu = () => import('@/components/VideoMenu.vue')
const Maintenance = () => import('@/components/Maintenance.vue')
const PortalNavMenu = () => import('@/components/PortalNavMenu.vue')
export default {
  name: 'App',
  data () {
    return {
      drawer: false,
      miniVariant: false,
      styleObject: {
        background: '#E53935',
        color: 'white',
        fontSize: '15px'
      },
      loading: false
    }
  },
  components: { Maintenance, AlertBar, VideoMenu, PortalNavMenu },
  mixins: [userAccess],
  computed: {
    readWriteAccess () {
      return this.hasWriteAccess ? 'write' : 'read'
    },
    maintenanceStatus () {
      return JSON.parse(process.env.VUE_APP_MAINTENANCE_STATUS)
    },
    navLinks () {
      const links = [
        { icon: 'mdi-barcode-scan', text: 'Items', path: '/items', show: true },
        { icon: 'mdi-barcode-scan', text: 'Pricing', path: '/pricing', show: (this.$auth.tenant === 'jbg' && this.$auth.isAdmin) },
        { icon: 'mdi-file-upload-outline', text: 'DSD Upload', path: '/upload', show: this.hasDsdUploadAccess },
        { icon: 'mdi-eye-off-outline', text: 'Item Restrictions', path: '/item-restrictions', show: this.isRestrictionManager }
      ]
      return links.filter(link => link.show)
    },
    tenantsWithLogos () {
      return [
        'awg',
        'alliance-retail-group'
      ]
    }
  },
  methods: {
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
      sessionStorage.removeItem('vendor_filters')
      sessionStorage.removeItem('item_search_filters')
      sessionStorage.removeItem('selectedSources')
      localStorage.removeItem('showDiscontinuedItems')
      localStorage.removeItem('selectedItemDetails')
      sessionStorage.removeItem('price_search_filters')
      sessionStorage.removeItem('source_filters')
    }
  }
}
</script>
<style>
.v-text-field__slot input::-webkit-calendar-picker-indicator {
  display: none;
}

.v-text-field__slot input[type="date"] {
  cursor: text;
}

.v-text-field__slot input[type="date"]::-webkit-input-placeholder {
  visibility: hidden;
}

span.registeredTrademark {
  position: relative;
  top: -.3rem;
  font-size: .5rem;
  left: -0.05rem;
}

footer {
  font-size: small;
}
.logo{
    max-height: 64px;
    max-width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue